exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-16887390] {\n    color: #495966;\n}\na[data-v-16887390]:hover {\n    color: #0056b3;\n}\n", ""]);

// exports
